"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var initialState = new _immutable.Map({
  workflowIds: new _immutable.Map()
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchEcommerceWorkflowIdsActionTypes.SUCCESS, function (state, action) {
  return state.set('workflowIds', new _immutable.Map(action.payload.data.workflows.reduce(function (acc, workflow) {
    acc[workflow.type] = workflow.id;
    return acc;
  }, {})));
}), initialState);

exports.default = _default;
module.exports = exports.default;